import { Component, Inject, OnInit, EventEmitter, Output, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { FormGroup, FormBuilder } from '@angular/forms';
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { SaveService } from '../../../../services/save.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatChipInputEvent } from "@angular/material/chips";

@Component({
    selector: "elevator-filter",
    templateUrl: './elevator-filter.component.html',
    styleUrls: ['../../../../style/form.component.less', 'elevator-filter.component.less', '../../../../style/expand-collapse-panel.component.less'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class ElevatorFilterComponent implements OnInit {

    form!: FormGroup ;
    @Output() outputFilter = new EventEmitter<ElevatorFilter>();

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];

    elevatorNicknames: string[] = [];
    buildingAddr1: string[] = [];
    buildingCities: string[] = [];
    unitIds: string[] = [];
    branchNumbers: string[] = [];
    controllerTypes: string[] = [];

    constructor(
        private http: HttpClient
        , private fb: FormBuilder
        , @Inject('BASE_URL') private baseUrl: string
    ) {
    }

    ngOnInit() {
        this.createForm();
    }

    createForm() {
        this.form = this.fb.group({
        });
    }

    changeTypeButton() {
        return this.unitIds.length < 1 && this.controllerTypes.length < 1
            && this.branchNumbers.length < 1 && this.elevatorNicknames.length < 1
            && this.buildingAddr1.length < 1 && this.buildingCities.length < 1
    }

    applyFilter(event: MatChipInputEvent, list: string): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            switch (list) {
                case 'branchnumbers':
                    this.branchNumbers.push(value.replace('+', '').trim()); break;
                case 'unitids':
                    this.unitIds.push(value.replace('+', '').trim()); break;
                case 'controllertypes':
                    this.controllerTypes.push(value.replace('+', '').trim());break;
                case 'elevatornicknames':
                    this.elevatorNicknames.push(value.replace('+', '').trim()); break;
                case 'buildingaddr1':
                    this.buildingAddr1.push(value.replace('+', '').trim()); break;
                case 'buildingcities':
                    this.buildingCities.push(value.replace('+', '').trim());
                    break;
            }
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    remove(item: string, list: string): void {
        let index = -1
        switch (list) {
            case 'branchnumbers':
                index = this.branchNumbers.indexOf(item);
                if (index >= 0)
                    this.branchNumbers.splice(index, 1);
                break;
            case 'unitids':
                index = this.unitIds.indexOf(item);
                if (index >= 0)
                    this.unitIds.splice(index, 1);
                break;
            case 'controllertypes':
                index = this.controllerTypes.indexOf(item);
                if (index >= 0)
                    this.controllerTypes.splice(index, 1);
                break;
            case 'elevatornicknames':
                index = this.elevatorNicknames.indexOf(item);
                if (index >= 0)
                    this.elevatorNicknames.splice(index, 1);
                break;
            case 'buildingaddr1':
                index = this.buildingAddr1.indexOf(item);
                if (index >= 0)
                    this.buildingAddr1.splice(index, 1);
                break;
            case 'buildingcities':
                index = this.buildingCities.indexOf(item);
                if (index >= 0)
                    this.buildingCities.splice(index, 1);
                break;            
        }
    }

    onFilter() {
        const filter: ElevatorFilter = {
            'ElevatorNicknames': this.elevatorNicknames,
            'BranchNumbers': this.branchNumbers,
            'BuildingAddr1': this.buildingAddr1,
            'UnitIds': this.unitIds,
            'BuildingCities': this.buildingCities,
            'ControllerTypes': this.controllerTypes
        }
        this.outputFilter.emit(filter);
    }
}